import apiHandler from "middlewares/apiHandler";
import { GHGTarget } from "pages/TargetForm/data/GHGTarget";
import { GHGTargetGridProps } from "pages/TargetForm/data/GHGTartgetGrid.type";

export const _addTargetForm = async (targetForm: GHGTarget) => {
  return apiHandler.post<GHGTarget>("GHGTarget", targetForm);
};

export const _getCustomGHGTargetsByLocationsId = async (locationId: number | undefined) => {
  return apiHandler.get<Array<GHGTargetGridProps>>(
    `CustomGHGTargets/location/${locationId}`
  );
};

export const _getGHGTargetsByTargetNumber = async (targetNumber: number | undefined) => {
  return apiHandler.get<GHGTarget>(
    `GHGTargets/${targetNumber}`
  );
};

export const _updateTargetForm = async (targetForm: GHGTarget) => {
  return apiHandler.put<GHGTarget>("GHGTarget", targetForm);
};

export const _deleteGHGTarget = async (targetNumber: number) => {
  return apiHandler.delete("GHGTarget/" + targetNumber);
};

export const _downloadGHGTargetTemplate = async (locationId: number): Promise<Blob | undefined> => {
  return apiHandler.get<Blob>(
    `GHGTargets/location/${locationId}/template`,
    "blob"
  );
};